import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { DialogVideoComponent } from './dialog-video.component';

@Injectable({
  providedIn: 'root',
})
export class VideoPlayerService {
  constructor(public dialog: MatDialog) {}

  show(videoUrl: string, lotCode: string) {
    return this.dialog.open(DialogVideoComponent, {
      width: '600px',
      data: { videoUrl, lotCode },
    });
  }
}
